module.exports = __webpack_public_path__ + "static/media/cello.bb300e15.wav";